// 统一引入api模块
import login from './login'

export default {
  login
}



// WEBPACK FOOTER //
// ./src/api/index.js